import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom/es";

import Dropdown, {
  DropdownContent,
  DropdownTrigger,
} from "react-simple-dropdown";

import {
  addDeviceGroup,
  addPriorityMessage,
  confirmationRequest,
  disablePriorityMessage,
  setPageTitle,
  updateContentFeed,
  updateDevice,
  updatePriorityMessage,
  addUserReport,
  fetchDeviceTags,
  addDeviceTag,
  fetchPlaylistsV2,
  fetchPagedPlayistsV2,
} from "../../actions";
import { searchStrFromRouterLocation } from "signoxe/utils/router";

import Box from "../../components/layout/Box";
import Page from "../../components/layout/Page";
import DeviceAddSaveCancelWidget from "../../components/widgets/DeviceAddSaveCancelWidget";
import { MultiregionToggleWidget } from "../../components/widgets/MultiregionToggleWidget";
import {
  getFilteredDevices,
  getFeatureStatus,
  getCurrentDeviceId,
  getPlaylistPreloadStateV2,
} from "../../selectors";
import { getProfile } from "../../selectors/profile";
import "./styles.scss";
import { searchDevices } from "signoxe/actions";

import {
  ContentModal,
  Button,
  Icon,
  SearchFilterBar,
  EmptyMessage,
  SelectFormField
} from "../../components/widgets";

import LocationComponent from "signoxe/utils/LocationComponent";

import UnassignedDevices from "./tabs/UnassignedDevices/UnassignedDevicesView";
import GroupedDevices from "./tabs/GroupedDevice/GroupedDevices";
import UngroupedDevices from "./tabs/UngroupedDevices/ungroupedDevices";
import PairDevice from "./tabs/PairDevice";
import { delete_pairing_code, generate_pairing_code } from "signoxe/actions/deviceActions";
import { 
  getPlaylistsV2,
  getFilteredPlaylistsV2,
  isFetchingPlaylistV2,
  getDeviceTagsAll } from "../../selectors";

class DevicesPage extends React.Component {
  static propTypes = {
    addUserReport: PropTypes.func.isRequired,
    generate_pairing_code: PropTypes.func.isRequired,
    delete_pairing_code: PropTypes.func.isRequired,
    searchDevices: PropTypes.func.isRequired,
    screenshotsEnabled: PropTypes.bool,
    smartBoardEnabled: PropTypes.bool,
    addDeviceGroup: PropTypes.func.isRequired,
    updateDevice: PropTypes.func.isRequired,
    confirmationRequest: PropTypes.func.isRequired,
    updateContentFeed: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    addPriorityMessage: PropTypes.func.isRequired,
    updatePriorityMessage: PropTypes.func.isRequired,
    disablePriorityMessage: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    searchString: PropTypes.string,
    isFetching: PropTypes.bool.isRequired,
    fetchDeviceTags: PropTypes.func.isRequired,
    addDeviceTag: PropTypes.func.isRequired,
    updateDeviceTag: PropTypes.func.isRequired,
    deleteDeviceTag: PropTypes.func.isRequired,

    profile: PropTypes.shape({
      username: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      activation_date: PropTypes.string.isRequired,
      renewal_date: PropTypes.string.isRequired,
      next_renewal_date: PropTypes.string.isRequired,
      profile: PropTypes.shape({
        name: PropTypes.string.isRequired,
        organisation_name: PropTypes.string.isRequired,
        organisation_address: PropTypes.string.isRequired,
        primary_contact_name: PropTypes.string.isRequired,
        primary_contact_phone: PropTypes.string.isRequired,
        primary_contact_email: PropTypes.string.isRequired,
        financial_contact_name: PropTypes.string.isRequired,
        financial_contact_email: PropTypes.string.isRequired,
        financial_contact_phone: PropTypes.string.isRequired,
        technical_contact_name: PropTypes.string.isRequired,
        technical_contact_email: PropTypes.string.isRequired,
        technical_contact_phone: PropTypes.string.isRequired,
      }).isRequired,
    }),
  };

  constructor(props) {
    super(props);
    this.state = props.profile ? props.profile.profile : null;
    this.state = {
      showMobileBox: true,
      showView: true,
      toggleCreateTag: false,
      toggleMobileCreate: false,
      searchTerm: '',
      selectedTab: `${localStorage.getItem("DevicesTab")? localStorage.getItem("DevicesTab"):'grouped devices'}`
    };
    // Debounce the handleSearch function
  
  }


handleUserReport = (message) => {
    const {profile} = this.props;
    if (profile && profile.features && profile.features.record_user_activity){
        this.props.addUserReport({
          user: profile.id,
          action_type: "Update",
          activity:message 
        });
      }
  }

  handleSearch = () =>{
    this.props.history.replace({
      search: `?search=${this.state.searchTerm}`,
    });
  }

  handleOnchange = (event) => {
    this.setState({ searchTerm: event.target.value });
      if(event.target.value.trim().length == 0){
        this.props.history.replace({
          search: `?search=${event.target.value}`,
        });
      }
  }


  onToggleCreateGroupMobile = (value) => {
    // desktop
    this.setState({ showView: false });
    this.setState({ toggleCreateTag : false });
    // mobile
    this.setState({ showMobileBox: value});
    this.setState({ toggleMobileCreate : !value });
  };

  onToggleShowView = (value) => {
    this.setState({ showView: value });
    this.setState({ showMobileBox: false });
    this.setState({ toggleMobileCreate : false });
    this.setState({ toggleCreateTag : false });
  };

  ToggleCreateTag_Dsp = () => {
    this.setState({ showView: !this.state.showView });
    this.setState({ showMobileBox: false });
    this.setState({ toggleMobileCreate : false });
    this.setState({ toggleCreateTag : !this.state.toggleCreateTag });
  };

  ToggleMobilCreateTag_Dsp = (value) => {
    // desktop
    this.setState({ showView: false });
    this.setState({ toggleCreateTag : false });
    // mobile
    this.setState({ showMobileBox: value });
    this.setState({ toggleMobileCreate : value });
  };

  handleAddDeviceTag = (name) => {
    (this.props.addDeviceTag({ name })) && (fetchDeviceTags(true))
  };

  handleAddDeviceGroup = (groupName) => {
    this.props.addDeviceGroup({ name: groupName });
    this.setState({ showView: !this.state.showView });
  };

  componentDidMount() {
    this.props.fetchDeviceTags(true);
    this.props.setPageTitle("Device Groups");
    this.props.searchDevices(""); // Clear any existing search query
    console.log("hello world")

    this.fetchNextPlaylist = setInterval(() => {
      if(this.props.next && this.props.next.length && !this.props.isFetching ){
        this.props.fetchPagedPlayistsV2(this.props.next);
      }
    }, 5000); // 60000 milliseconds = 1 minute

  }


  componentWillUnmount() {
    clearInterval(this.fetchNextPlaylist);
  }


  showText(text) {
    return <span className="show-text">{text}</span>;
  }

  currentView () {
    switch (this.state.selectedTab) {
      case 'grouped devices':
        return <>
          <GroupedDevices
            history={this.props.history}
            deviceTags={this.props.deviceTags}
          />
        </>
    
      case 'ungrouped devices':
        return<>
          <UngroupedDevices
            history={this.props.history}
            deviceTags={this.props.deviceTags}
          />
        </>
      
      case 'unassigned devices':
        return<>
          <UnassignedDevices/>
        </>
      
      case 'Pairing Codes':
        return<>
          <PairDevice delete_pairing_code={this.props.delete_pairing_code} />
        </>
        
      default:
        return<>
        </>
    }
  }

  changeTab(value){
    this.setState({selectedTab:value})
    localStorage.setItem("DevicesTab", `${value}`);
  }

  download = () => {
    let dummyData = ""

    this.props.devices.length > 0 && this.props.devices.map((data, index) => (
        dummyData = dummyData+data.code+","+data.device+","+data.license+","+data.activation_date+","+data.expiry_date+"\n"
        
    ))
    //const dummyData = "rahul,delhi,accountsdept\nrahul,delhi,accountsdept\nrahul,delhi,accountsdept\n";
    const csvContent = `data:text/csv;charset=utf-8,${dummyData}`;
    const encodedURI = encodeURI(csvContent);
    window.open(encodedURI);
  };

  render() {
    const { showMobileBox, showView, toggleCreateTag, toggleMobileCreate, searchTerm } = this.state;
    const {searchString } = this.props
    const self_activation = localStorage.getItem('self_activation')
    // console.log("plalylist", this.props.playlists)
    // console.log("next", this.props.next)

    const ativeTabDot = (tab) => {
      return this.state.selectedTab == tab?
      <span className="selectedRound"></span>
      : <span className="selectedRoundDummy"></span>
    }
    
    const profile = this.props.profile
    const allowed_pages = profile && this.props.profile.allowed_pages
    const isAllowed = profile && allowed_pages && this.props.profile.allowed_pages.channels_page

    return (
      <Page isAllowed={isAllowed}>
        <Box
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="menu-box"
        >
          {
            this.state.selectedTab != 'Pairing Codes' && this.state.selectedTab != 'unassigned devices'? 
              <>
             
                {showView == true &&  toggleCreateTag == false?
                <div className="input-group">
                 <input
                   className={`input-group-2 ${this.state.selectedTab == 'unassigned devices'? 'visibility-hidden' : 'visibility-visible'}`}
                   type="text"
                   value={searchTerm}
                   placeholder={this.state.selectedTab == 'grouped devices'? "Search Device groups" :'Search for a Device'}
                   onChange={this.handleOnchange}
                 />
                 <span onClick={this.handleSearch} className="input-group-label is-cursor">
                  Search
                 </span>
               </div>
                 :<div>
                    { toggleCreateTag != true ? 
                      (<DeviceAddSaveCancelWidget
                        onSave={this.handleAddDeviceGroup}
                        onToggle={this.onToggleShowView}
                      />):(<DeviceAddSaveCancelWidget
                        addLabel="Add Device Tag"
                        onToggle={this.ToggleCreateTag_Dsp}
                        onSave={this.handleAddDeviceTag}
                      />)
                    }
                  </div>
                }
              </>
            : <div className='input-group 2.6.2 SearchBar input-group-2'>
              <input
                type="text"
                placeholder="Search Devices"
                className="input-group-field"
              />
              <span className="input-group-label">
                <Icon title="Search" name="search" size="1rem" />
              </span>
              <Box direction="row" alignItems="center" className="resumable small">
                <div style={{ marginLeft: "10px" }}>
                </div>
              </Box>
            </div>
          }
          <Box className='topNav' wrap={false}>
            {
              this.state.selectedTab != 'Pairing Codes'? 
                <>
                  {
                    this.state.selectedTab == 'grouped devices' ?
                    <span
                      onClick={() => this.onToggleShowView(!this.state.showView)}
                      className="device-action-icon-device"
                      style={{ 'margin': '0 0.5rem' }}
                    >
                      <Icon
                        title={showView &&  toggleCreateTag == false? "new Group" : "Switch to Search Bar"}
                        name={showView &&  toggleCreateTag == false? "plus-circle" : "search"}
                        size="1.5rem"
                        />
                      {this.showText(
                        showView ? "New Group" : "Switch to Search Bar"
                      )}
                    </span>
                    :null
                  }

                  {
                    this.state.selectedTab != 'unassigned devices' && 
                    this.state.selectedTab != 'Pairing Codes' && this.props.profile != undefined && 
                    this.props.profile.profile.package.device_tags?
                    <span
                      onClick={() => (this.ToggleCreateTag_Dsp())}
                      className="device-action-icon-device"
                      style={{ 'margin': '0 0.5rem' }}
                    >
                      <Icon
                        title={"Create Tag"}
                        name={"plus-circle"}
                        size="1.5rem"
                        />
                      {this.showText(
                        "Create Tag"
                      )}
                    </span>
                    :null
                  }

                  {
                    this.props.profile &&
                      this.props.profile.features &&
                      this.props.profile.features.multiregion ? (
                      <MultiregionToggleWidget
                        label="Enable multiregion"
                        profile={this.props.profile}
                      />
                    ) : null
                  }
                </>
              : <div style={{marginRight:'1rem'}}>
                  <Button onClick={() => this.download()}>Export</Button>
                  <Button onClick={() => this.props.generate_pairing_code()}>Generate Code</Button>
              </div>
            }
            <span
              // onClick={() => this.props.history.push("/devices/unassigned")} 
              className="device-action-icon-device"
              // style={{ 'margin': '0 0.5rem' }}
            >
              <SelectFormField
                id={'selectTab'}
                label={''}
                defaultValue={this.state.selectedTab}
                options = {
                  self_activation == 'true'? 
                    [
                      { value:'grouped devices', label:'Grouped Devices'},
                      {value:'ungrouped devices', label:'Ungrouped Devices'},
                      {value:'unassigned devices', label:'Unassigned Devices'},
                      {label:'Pairing Codes', value:'Pairing Codes'}
                    ]
                  : [
                    { value:'grouped devices', label:'Grouped Devices'},
                    {value:'ungrouped devices', label:'Ungrouped Devices'},
                    {value:'unassigned devices', label:'Unassigned Devices'},
                  ]
                } 
                onChange={(e) => this.changeTab(e.currentTarget.value)}
              />
            </span>
          </Box>
        </Box>

        <Box
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="menu-box-mobile"
        >
          {showMobileBox ? (
            this.state.selectedTab == 'grouped devices' || 'ungrouped devices'?
            
            <div className="input-group">
            <input
              className={`input-group-2 ${this.state.selectedTab == 'unassigned devices'? 'visibility-hidden' : 'visibility-visible'}`}
              type="text"
              value={searchTerm}
              placeholder={this.state.selectedTab == 'grouped devices'? "Search Device groups" :'Search for a Device'}
              onChange={this.handleOnchange}
            />
            <span onClick={this.handleSearch} className="input-group-label is-cursor">
            <Icon title="Search" name="search" size="1rem" />
            </span>
          </div>
            :null
          ) : (
            <div>
              { toggleMobileCreate === true ? 
                (<DeviceAddSaveCancelWidget
                    addLabel="Add device group"
                    onSave={this.handleAddDeviceGroup}
                    onToggle={this.onToggleCreateGroupMobile}
                  />
                ):(<DeviceAddSaveCancelWidget
                  addLabel="Add Device Tag"
                  onToggle={this.ToggleMobilCreateTag_Dsp}
                  onSave={this.handleAddDeviceTag}
                />)
              }
            </div>
          )}

          {showMobileBox ? (
            <Dropdown>
              <DropdownTrigger>
                <button type="button" className="button">
                  <span style={{ marginRight: "5px", fontSize: "0.7rem" }}>Actions</span>
                  <span
                    title="actions"
                    className="icon fa fa-caret-down"
                    style={{ fontSize: "1rem", color: "#fff" }}
                  ></span>
                </button>
              </DropdownTrigger>
              <DropdownContent className="user-menu actions-menu card depth-1">
                <li onClick={()=>this.changeTab('grouped devices')}> {ativeTabDot('grouped devices')} Grouped Devices </li>
                <li onClick={()=>this.changeTab('ungrouped devices')}> {ativeTabDot('ungrouped devices')} Ungrouped Devices</li>
                <li onClick={()=>this.changeTab('unassigned devices')}> {ativeTabDot('unassigned devices')} Unassigned Devices</li>
                <li onClick={()=>this.changeTab('Pairing Codes')}> {ativeTabDot('Pairing Codes')} Pairing Codes</li>
                {
                  this.state.selectedTab == 'grouped devices'?
                    <li
                      onClick={() =>
                        this.onToggleCreateGroupMobile(!this.state.showMobileBox)
                      }
                    >
                      <span className="selectedRoundDummy"></span>
                      Add a New Group
                    </li> : null
                }

                {
                  this.state.selectedTab != 'unassigned devices' && this.state.selectedTab != 'Pairing Codes' && this.props.profile != undefined && this.props.profile.profile.package.device_tags?
                  <li
                    onClick={() => this.ToggleMobilCreateTag_Dsp(!this.state.showMobileBox)}
                  >
                    <span className="selectedRoundDummy"></span>
                      Create Tag
                  </li> : null
                }

                {this.props.profile &&
                  this.props.profile.features &&
                  this.props.profile.features.multiregion ? (
                    <li>
                    <MultiregionToggleWidget
                      label="Enable multiregion"
                      profile={this.props.profile}
                    />
                  </li>
                ) : null}
              </DropdownContent>
            </Dropdown>
          ) : null}
        </Box>

        {this.currentView()}
      </Page>
    );
  }
}

export default connect(
  (state, props) => {
    const searchString = searchStrFromRouterLocation(props.location);
    console.log(state)
    return {
      searchString,
      
      profile: getProfile(state),
      screenshotsEnabled: getFeatureStatus(state, "screenshots"),
      smartBoardEnabled: getFeatureStatus(state, "smart_notice_board"),
      deviceReportingEnabled: getFeatureStatus(state, "device_reporting"),
      rebootEnabled: getFeatureStatus(state, "reboot_device"),
      RestartAppEnabled: getFeatureStatus(state, "restart_app_enabled"),
      ClearUnusedMediaEnabled: getFeatureStatus(state, "clear_unused_media_enabled"),
      offlineEnabled: getFeatureStatus(state, "offline_device"),
      delayDownloadEnabled: getFeatureStatus(state, "delayed_download"),
      currentDeviceId: getCurrentDeviceId(state),
      devices: state.deviceState.deviceReducer.paring_codes,
      deviceTags: getDeviceTagsAll(state),
      playlists: getPlaylistsV2(state),
      filteredlist: getFilteredPlaylistsV2(state, ""),
      next: getPlaylistPreloadStateV2(state),
      isFetching: isFetchingPlaylistV2(state),


  };
  },
  {
    addDeviceGroup, 
    updateDevice,
    updateContentFeed,
    confirmationRequest,
    setPageTitle,
    addPriorityMessage,
    updatePriorityMessage,
    disablePriorityMessage,
    searchDevices,
    addUserReport,
    delete_pairing_code, 
    generate_pairing_code,
    fetchDeviceTags,
    addDeviceTag,
    fetchPlaylistsV2,
    fetchPagedPlayistsV2,
  }
)(DevicesPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/DevicesPage/index.js